document.addEventListener('change', function (event) {
  const target = event.target;
  const isRadio = target.matches('variant-selects input[type="radio"]');
  const isSelect = target.matches('variant-selects select');

  if (!isRadio && !isSelect) return;

  let url;
  if (isRadio) {
    url = target.dataset.productUrl;
  } else {
    const selectedOption = target.options[target.selectedIndex];
    url = selectedOption ? selectedOption.dataset.productUrl : null;
  }

  if (url) {
    window.location.href = url;
  }
});